module.exports = __webpack_public_path__ + "static/media/deeplearning.66fb6330.webp";